import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const productBinCountsSchema = z.object({
  productId: productIdFormat.schema,
  counts: z.array(
    z.object({
      storageLocationId: storageLocationIdFormat.schema,
      quantity: z.number().int().nonnegative(),
    }),
  ),
});

/** Cancelling every remaining unit empties the order, which is a full order cancel instead. */
export function cancelLeavesNoItems(
  lineQuantities: readonly number[],
  cancelQuantities: readonly number[],
): boolean {
  const remaining = lineQuantities.reduce((sum, quantity) => sum + quantity, 0);
  const cancelled = cancelQuantities.reduce(
    (sum, quantity) => sum + quantity,
    0,
  );
  return remaining - cancelled <= 0;
}

export const cancelOrderItems = {
  name: "cancelOrderItems" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    items: z.array(
      z.object({
        fulfillmentOrderLineItemId: z.string(),
        quantity: z.number().int().positive(),
      }),
    ),
    restock: z.boolean(),
    notifyCustomer: z.boolean(),
    /** WMS source of truth: bins to set to a counted quantity after the cancel. */
    binCounts: productBinCountsSchema.nullish(),
    /** WMS source of truth: bin counts for several products, one entry per product. */
    productBinCounts: z.array(productBinCountsSchema).nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    cancelledCount: z.number(),
    binCountsFailed: z.boolean(),
  }),
};
